const main_sidebar = {
  summary: false,
  snakeLine: false,
  curve: true,
  map: true,
  layout: true,
  data: true,
  chart: true,
  export: true,
  dashboard: true,
  monitor: true,
  slope: false,
  storm: false,
  alerts: false,
  occ:false,
};

const thsr_sidebar = {
  summary: false,
  snakeLine: false,
  curve: false,
  map: false,
  layout: false,
  data: false,
  chart: false,
  export: false,
  dashboard: true,
  monitor: true,
  slope: true,
  storm: true,
  alerts: true,
  occ:true,
};

// 2023/12/11 目前更新至33faf63..版，分布曲線介面調整
// 2024/01/09 目前更新至b25d011..版，chart圖調整
// 2024/01/11 目前更新至0a112f2..版，chart圖再調整
// 2024/01/11 目前更新至c0b8f33..版，地圖更新
// 2024/01/11 目前更新至f103b66..版，地圖再調整
// 2024/01/17 目前更新至d0eba2e..版，chart加高
// 2024/02/02 目前更新至da6af20..版，OCC人員可視事件紀錄
// 2024/02/02 目前更新至fd755a2..版，chart圖調整
// 2024/02/02 目前更新至65b0ffe..版，OCC人員可視chart
// 2024/02/06 目前更新至3fc00ac..版，新增OCC聯絡人
// 2024/02/07 目前更新至9dd9e23..版，更新OCC聯絡人內容
// 2024/02/16 目前更新至b7ed306..版，修復各種bug與更新OCC/Log頁面
// 2024/02/26 目前更新至915faba..版，修復缺乏advanced類別API導致的問題
// 2024/02/26 目前更新至ad72dd5..版，新增advanced獲取選取的專案下儀器的手段
// 2024/02/26 目前更新至276390c..版，bug修復
// 2024/02/26 目前更新至448263f..版，bug修復
// 2024/02/26 目前更新至5bde462..版，bug修復
// 2024/02/27 1.14.0 更新至721fde5..版，更新log頁面，並添加每3月要求更新密碼之功能
// 2024/02/27 1.14.1 更新至1ffb8ec..版，優化log頁面
// 2024/02/29 1.14.2 更新至aaeda49..版，使advOption可見所選專案的測站/區域
// 2024/02/29 1.14.3 更新至7eefbe1..版，非admin/noiot人員會屏蔽advOption選項
// 2024/03/01 1.14.4 更新至0f42c16..版，bug修復，並新增了occ區域燈號
// 2024/03/01 1.14.5 更新至760721d..版，移除了修改暴雨系統密碼的API
// 2024/03/01 1.14.6 更新至412c7c5..版，修復OCC的bug
// 2024/03/07 1.14.7 更新至e1f3dcc..版，儀錶板顯示GIS名稱
// 2024/03/18 1.14.8 更新至e481115..版，大改chart版面設計
// 2024/03/18 1.14.9 更新至5608433..版，調整英文譯名
// 2024/03/18 1.14.10 更新至4f7a7c2..版，調整export頁面
// 2024/03/27 1.14.11 更新至b64b3ca..版，chart/curve更新
// 2024/03/27 1.14.11 更新至aa3023a..版，bug fix
// 2024/03/27 1.14.12 更新至a33d7ea..版，可以設定任意專案地圖起始點
// 2024/03/28 1.14.13 更新至3a7af59..版，curve UI調整與bug fix
// 2024/03/28 1.14.14 更新至c4fce3d..版，水平向curve UI修正
// 2024/04/01 1.14.15 更新至563388a..版，bug修正
// 2024/04/01 1.14.16 更新至ed90c16..版，bug修正
// 2024/04/01 1.14.17 更新至900faec..版，時差bug修正
// 2024/04/01 1.14.18 更新至d235d1c..版，chart table bug修正
// 2024/04/01 1.14.19 更新至308c640..版，chart輸出圖片與chart比例相符
// 2024/04/08 1.14.20 更新至394db1e..版，按鈕顏色調整
// 2024/04/19 1.14.21 更新至84f3f10..版，修復一些錯誤
// 2024/04/19 1.14.22 更新至df6e2d9..版，修復一些錯誤
// 2024/04/25 1.14.23 更新至df03edc..版，修復雨量計顯示表格無內容之錯誤
// 2024/04/25 1.14.24 更新至78148d5..版，使使用者無法使用進階選項新增專案
// 2024/05/15 1.14.25 更新至ed6ffde..版，調整地圖instrument status顯示的內容
// 2024/05/23 1.14.26 更新至ef194a4..版，使endOnTick可以順利反映
// 2024/05/28 1.14.27 更新firebase.json，新增headers
// 2024/05/28 1.14.28 更新firebase.json，調整CSP
// 2024/06/03 1.14.29 更新至86a9bd0..版，大改數據排名表
// 2024/06/24 1.14.30 更新至0cbafd1..版，修復特定情況下chart調整上下線時沒有反應之問題
// 2024/07/01 1.14.31 更新至61be0ab..版，curve新增auto scale
// 2024/07/04 1.14.32 更新至151b56d..版，Curve與Snakeline設定白色背景
// 2024/07/15 1.14.33 更新至53b01cf版，shpjs相關版本升級
// 2024/07/16 1.14.34 更新至e69b935版，highcharts版本升級
// 2024/07/17 1.14.35 更新至4f0c6a0版，highcharts棄用option調整畫面，改用css+className+styleMode調整畫面
// 2024/07/17 1.14.36 更新至517d4a4版，禁用聯集選擇器的hover模式
// 2024/08/01 1.14.37 更新至f83c612版，更新儀器排行表新增功能，地圖優化
// 2024/08/06 1.14.38 更新至d962301版，更新預設頁面與噪音計
// 2024/09/02 1.15.01 更新至7270362版，大更新，新增給儀器設定計算function的功能，並調整一些chart的顯示
// 2024/09/12 1.15.02 更新至d87bdb8版，調整噪音計與地圖雨量透明的顯示
// 2024/10/08 1.15.03 更新至d128509版，新增計算公式的設定畫面(未完成)，並添加禁用儀器的按鈕
// 2024/10/08 1.15.04 更新至207c240d版，更新不少東西
// 2024/10/08 1.15.05 更新至83cd5917版，更新occ
// 2024/11/13 1.15.06 更新至4df6436版，人工量測fix bug
// 2024/11/13 1.15.07 更新至2be2cd6版，人工量測import初版
// 2024/12/06 1.15.08 更新至c452688版，人工量測import-kmrt版
// 2024/12/06 1.15.09 更新至e0d8f81版，新增kmrt圖標
// 2024/12/10 1.15.10 更新至d8dd853版，人工監測edit bug fix
// 2024/12/24 1.15.11 更新至6600840版，人工監測數據列表調整、現在"關於"部分可透過專案進行編輯
// 2024/12/24 1.15.12 更新至ec2facf版，噪音計bug fix
// 2024/12/31 1.15.13 更新至94962c0版，噪音計匯出csv
// 2025/01/15 1.15.14 更新至28b2991版，噪音計匯出格式調整
// 2025/01/15 1.15.15 更新至26508df版，噪音計頁面調整
// 2025/01/16 1.15.15 更新至0a99f54版，噪音計 leq5m 上限條件修改
// 2025/03/31 1.16.00 更新至de7da70版，高鐵arcgis界接
// 2025/03/31 1.16.01 更新至3cc2b00版，高鐵arcgis更新
// 2025/03/31 1.16.02 更新至74ec279版，高鐵arcgis與高鐵的版本同步 
// 2025/04/08 1.16.03 更新至bf08be2版，高鐵arcgis更新 
// 2025/04/08 1.16.04 更新至070c974版，高鐵arcgis更新 
// 2025/04/09 1.16.05 更新至91f0c41版，高鐵arcgis更新
// 2025/04/09 1.16.06 更新至0e5a6a0版，高鐵arcgis更新
// 2025/04/09 1.16.07 更新至e3e8bb9版，高鐵arcgis切換到正式環境
// 2025/05/13 1.16.08 更新至54c3d22版，高鐵arcgis微調
// 2025/05/14 1.16.09 更新至7642afc版，SnakeLine Bug Fix
// 2025/05/19 1.16.10 更新至7c554eb版，噪音計頁面調整
// 2025/05/21 1.17.00 更新至7fd025d版，歷時曲線優化/儀錶板內容調整
// 2025/05/26 1.17.01 更新至7dd810b版，歷時曲線警戒線bug fix
// 2025/05/26 1.18.00 更新至64ee1a8版，SMS頁面調整/人工量測新增tooltip/CCTV頁面群組名稱排序
// 2025/07/03 1.18.01 更新至b3dffd9版，邊坡CCTV 群組名稱顯示方式調整
// 2025/07/07 1.19.00 更新至de75221版，新增出高鐵報告的頁面、並調整人工量測的一些內容
// 2025/07/24 1.19.01 更新至91840cf版，KMRT更新與颱風報告２４小時雨量圖、ARCGIS介接
// 2025/07/30 1.20.00 更新至c584929版，KMRT更新與OCC調整，chart prop與query併用
// 2025/08/06 1.20.01 更新至3449fcf版，OCC介面調整調整
// 2025/08/06 1.20.02 更新至316b803版，OCC介面調整調整
// 2025/08/12 1.20.03 更新至6d73c77版，數據排名表改為倒推24hr
// 2025/08/15 1.20.04 更新至7fb3dfa版，SMS參考emt001的格式
// 2025/08/21 1.20.05 更新至683d165版，OCC頻率改成五分鐘
// 2025/08/25 1.20.06 更新至96344bb版，auto refresh fix、occ alert api優化
// 2025/08/26 1.20.07 更新至562d004版，SMS葉面當訊息找不到對應的儀器時隱藏，且當用戶為OCC人員時隱藏非TM的儀器，chart scale bug fix
// 2025/08/27 1.20.08 更新至3b6643b版，occ bug fix
// 2025/08/28 1.20.09 更新至7737248版，正名
// 2025/08/28 1.20.10 更新至1f65b9e版，速率極性fix與chart按鈕不跳轉，occ 預設登入 occ頁面
// 2025/09/02 1.20.11 更新至630fcd9版，更新dompurify版本&"修正地圖儀器名稱顯示問題 & 高鐵 dashboard map 燈號顯示邏輯 & 儀器排名表可選7天"
// 2025/09/04 1.20.12 更新至c53e5ec版，備註下放
// 2025/09/04 1.20.13 更新至1a41b4d版，KMRT匯入修復、自動清空、SIS讀取欄位調整
// 2025/09/10 1.20.14 更新至7213680版，OCC調整，中文顯示、mapbox market chart btn fix、颱風報告調整
// 2025/09/10 1.20.15 更新至617b8de版，備註頁面可選使用儀器或時間區間
// 2025/09/12 1.20.16 更新至d7fb52a版，調整OCC DWS的顯示
// 2025/09/25 1.20.17 更新至cc785aa版，OCC聯絡人新增高sir
// 2025/09/30 1.20.18 更新至b609e48版，新增特徵分析
// 2025/10/01 1.20.19 更新至7c50512版，特徵分析UI更新
// 2025/10/01 1.21.00 更新至ba2c192版，颱風報告調整&新增週報工具，新增台安人員
// 2025/10/02 1.21.01 更新至9b29944版，SMS頁面改版
// 2025/10/02 1.21.02 更新至72a7797版，手機板可見OCC按鈕
// 2025/10/14 1.21.03 更新至f52e8a1版，颱風自動報告修正 & 週報圖表自動產生(完整版)
// 2025/10/15 1.21.04 更新至dc97928版，新增用戶活動監控頁面
// 2025/10/15 1.21.05 更新至17ccd20版，排序fix
// 2025/10/15 1.21.06 更新至e74f0b9版，表格輸出調整&新增雨量輸出，自動報告調整
// 2025/10/29 1.21.07 更新至11d1eec版，新增自動產出月報圖表
// 2025/11/06 1.22.00 更新至7e24593版，新增地震報告，並調整監測月報
// 2025/11/07 1.22.01 更新至5939394版，新增頻率檢核
// 2025/11/17 1.22.02 更新至2c43942版，特徵分析新增TI突波
// 2025/11/19 1.22.03 更新至8521b8a版，新增臺鐵邊坡監測 專用 dashboard，關閉一些不適用於高捷的選項
// 2025/11/21 1.22.04 更新至ffb82a5版，高捷紅黃單版面修正，台鐵專用dashboard調整
// 2025/11/23 1.22.05 更新至2b34ba5版，版面微調，bug fix
// 2025/11/27 1.22.06 更新至4ceef41版，登入/banner UI調整
// 2025/12/01 1.22.07 更新至b2ce8e1版，自動產出報告優化/調整，人工量測上傳前數據檢查，高捷新增特定使用者
// 2025/12/01 1.22.08 更新至b728498版，填入/匯入資料前檢查資料是否存在，匯入template提供下載
// 2025/12/05 1.22.09 更新至0e77836版，名稱調整
// 2025/12/05 1.22.10 更新至b929dc5版，人工量測可編輯座標/下載模板調整
// 2025/12/12 1.22.11 更新至a7158b0版，人工量測匯入調整&儀器類型清單調整
// 2025/12/24 1.22.12 更新至c754c43版，台鐵dashboard / 更新 新版GIS
// 2025/12/24 1.22.13 更新至ddbee75版，台鐵dashboard調整，GIS圖層調整，平面圖調整，人工量測調整
// 2025/12/29 1.22.14 更新至2ec1717版，人工量測對於LC的調整
// 2025/12/29 1.22.15 更新至047d799版，資料列表調整，Dashboard調整
// 2026/01/05 1.22.16 更新至45de304版，匯入錯誤檢查
// 2026/01/06 1.22.17 更新至6798c8e版，下載文件bug fix
// 2026/01/06 1.22.18 更新至db75a30版，新增專案-用戶關聯
// 2026/01/13 1.22.19 更新至8fcfff9版，查詢用戶關聯優化與新增查詢類型
// 2026/01/21 1.22.20 更新至3d8d181版，專案-用戶清單中添加確認line的使用狀態
// 2026/01/21 1.22.21 更新至d938e27版，調整頻率按鈕的文本
// 2026/01/30 1.23.00 更新至40e5164版，輸出檔案調整、月報調整、修復地圖、ITD portal問題fix
// 2026/02/10 1.23.01 更新至cf3ea6c版，新增暴雨儀表板，黃紅單流水號調整
// 2026/02/11 1.23.02 更新至0a1aa65版，黃紅單調整
// 2026/03/02 1.23.03 更新至2aeef28版，高鐵月報生成，歷年TM分為三組下載
// 2026/03/10 1.23.04 更新至095d0f6版，匯入調整
// 2026/03/10 1.23.05 更新至ed2a9b1版，依高鐵審查意見調整自動產出月報功能
// 2026/03/18 1.23.06 更新至aefe370版，修正manual/edit排序後輸入數據亂掉的bug
// 2026/03/19 1.23.07 更新至caa9485版，修正date fix
// 2026/03/24 1.23.08 更新至92b464d版，事件紀錄增加警戒行動的顯示單位
// 2026/03/24 1.23.09 更新至404650b版，儀器排序/重新計算變化量/調整初值時間/早於初值時間提示
// 2026/03/30 1.23.10 更新至8844884版，人工儀器數據上傳排除
// 2026/03/31 1.23.11 更新至9c8d1a4版，人工儀器/儀器組新增"重設初值"功能
// 2026/04/07 1.23.12 更新至809e02f版，inline style block fix
// 2026/04/08 1.23.13 更新至722b57e版，管理員儀器清單新增2個tab
// 2026/04/10 1.23.14 更新至87e55d8版，mapcomponets getRainMessage更換api
// 2026/04/13 1.23.15 更新至812dd9d版，新增alertGroup的顯示
// 2026/04/14 1.23.16 更新至6a77197版，匯出alertGroup的設定
// 2026/04/15 1.23.17 更新至cd35a3c版，關閉使用recheckInstrumentAlertStatus
// 2026/04/17 1.23.18 更新至0c3a372版，調整名稱顯示
// 2026/04/20 1.23.19 更新至1bfb4ec版，歷時曲線耗時顯示
// 2026/04/23 1.23.20 更新至faf946c版，新增與設定alertgroup，修復chart註點的點擊靈敏度與顯示完整性
// 2026/04/23 1.23.21 更新至7c9ca10版，高鐵月報/地震報告調整
// 2026/04/27 1.23.22 更新至4ab2feb版，優化OCC/人工量測
// 2026/04/27 1.23.23 更新至e3d2ae7版，bug fix，人工量測優化
// 2026/05/08 1.24.00 更新至c131ef8版，影像辨識UI初版
// 2026/05/08 1.24.01 更新至c6cdf30版，影像辨識UI調整，OCC區域燈號調整
// 2026/05/19 1.25.00 更新至b7e6385版，人工量測整合、RainGrid
// 2026/05/20 1.25.01 更新至4a9388e版，人工量測歷時曲線/分布曲線，主/子專案
// 2026/05/20 1.25.02 更新至702bee2版，儀錶板優化與重構
// 2026/05/20 1.25.03 更新至0279e41版，bug fix
// 2026/05/22 1.25.04 更新至4ecd6cb版，暴雨網格跳轉snakeline，關閉預測偏移顯示，資策會影像辨識API呼叫會帶上token
// 2026/05/25 1.25.05 更新至9fe22e7版，人工量測儀器組顯示offset，高鐵人工bug fix，人工數據列表時間fix
// 2026/05/26 1.25.06 更新至3ff39d8版，儀器排序&頻率按鈕&selectedInstrumentList清空 bug修復
// 2026/05/26 1.25.07 更新至59e59fb版，Log 畫面更新，登入錯誤顯示更新，新增登入三次失敗會停止15分鐘
// 2026/05/26 1.25.08 更新至07d2195版，人工量測數據輸入之selectedInstrumentList清空 bug修復，儀器頻率設定未重新載入bug fix
// 2026/05/27 1.25.09 更新至5706a73版，登入/密碼重置機制更新，新增密碼不可與前三次相同
// 2026/05/28 1.25.10 更新至b72db98版，安全性調整、log調整、系統健康表顯示內容調整、資策會多變數UI初版，高鐵邊坡移除無用儀器類型
// 2026/05/29 1.25.10 更新至246a825版，安全性調整，bulk/uploadInstrument反饋顯示
// 2026/06/01 1.25.11 更新至b90d0a8版，多變數頁面，人工量測/頻率檢測 bug fix
// 2026/06/02 1.25.12 更新至13faa30版，更多安全性更新，加入admin session頁面
// 2026/06/03 1.25.13 更新至a56bf3b版，影像辨識URL調整，調整jwt機制
// 2026/06/04 1.25.14 更新至9fa0841版，雨量網格欄位調整，影像辨識host調整，AI辨別設定
// 2026/06/08 1.25.15 更新至7bb2d6d版，人工新增儀器組初值日期 bug fix
// 2026/06/09 1.25.16 更新至8d3138f版，資安更新&雨量網格snakeline event bug fix，多變數新增突波
// 2026/06/09 1.25.17 更新至4101f1c版，資安更新，PIN改成MARKER
// 2026/06/16 1.25.18 更新至a53b02d版，資安更新，改用本地ROBOTO字型
// 2026/06/17 1.25.19 更新至79799dd版，dompurify版本升級
// 2026/06/17 1.25.20 更新至3bceaed版，調整一天雨量算法，當儀器的document或datakey不存在時顯示"{無}"
// 2026/06/25 1.26.00 更新至7248b38版，客戶管理清單調整，其他頁面微調
// 2026/06/26 1.26.01 更新至3721db4版，高鐵儀錶板bug修復，密碼OTP驗證
// 2026/06/29 1.26.02 更新至d9d45d6版，密碼複雜度提升&數據計算加format
// 2026/06/29 1.26.03 更新至434ee4d版，顯示token時長(暫時停用)，raingrid snakeline bug 修復
// 2026/06/30 1.26.04 更新至c66f1e4版，調整月報時間自動選取的邏輯
// 2026/07/02 1.26.05 更新至84a6919版，新增高捷對外頁面，資策會健康頁面
// 2026/07/03 1.26.06 更新至a45882d版，高鐵地圖載入人工儀器點位
// 2026/07/08 1.26.07 更新至4c605c0版，使用者新增AI判斷勾選框，登入畫面底下顯示安全升級公告。資料饋送健康檢查表移除專案ID欄位
// 2026/07/09 1.26.08 更新至e34abed版，歷時曲線、新版告警機制未啟用表bug fix
// 2026/07/20 1.26.09 更新至cfe279f版，高捷公開資料， 分布曲線切換儀器組保持已選時間
// 2026/07/20 1.26.10 更新至0509383版，人工量測儀器參數設定調整
// 2026/07/21 1.26.11 更新至f685c6f版，健康檢查頁面新增CCTV模型狀態區塊
// 2026/07/21 1.26.12 更新至e236381版，開放指定人士有管理權限(僅開放Output、Instrument)
// 2026/07/27 1.26.13 更新至ecf3f16版，儀器簡訊設定新增AI分析開關，並於專案告警設定新增傳送參考儀器歷時曲線開關
// 2026/07/31 1.26.14 更新至5cd60cf版，CCTV AI 影像調整 API，新增 retired 區域 並且不計算在 dashboard
// 2026/08/05 1.26.15 更新至be72816版，暴雨預警調整：RainGrid實際截止時間改為日期選擇，SnakeLine事件結束改用實際時間差計算
// 2026/08/06 1.26.16 更新至4db1185版，恢復 NavBar Session 剩餘時間與刷新按鈕；新增儀器 Output 缺值補值工具（前端算法試算、雙圖預覽、可編輯確認後才寫入）
// 2026/08/17 1.26.17 更新至fd24a89版，修正 Session 刷新按鈕登入後不即時顯示，並在 token 過期時提示重新登入
// 2026/08/19 1.26.18 更新至88e57ee版，人工量測數據編輯於日期選擇器高亮顯示已存在數據的日期。sidebar調整。
// 2026/08/19 1.26.19 更新至9580a0d版，人工量測 Edit/Instrument 頁面新增 client 角色 1 日編輯窗口機制，並讓 admin/edit 角色可視覺辨識已鎖定欄位；KMRT專案新增專用的區域選單
// 2026/08/24 1.26.20 更新至ff26183版，補值工具調整
// 2026/08/25 1.26.21 更新至a360268版，RainGrid 燈號查詢歷史日期時改顯示區間內最嚴重警戒等級，查詢當天則維持原本即時狀態邏輯
// 2026/08/27 1.26.22 更新至9fd62cd版，凍結用戶預設不顯示，歷時曲線rate bug修正
// 2026/09/02 1.26.23 更新至9105f9c版，新增凍結專案，邊坡告警人員設定排版重新調整，用戶清單新增解除15分鐘登入失敗鎖定
// 2026/09/03 1.26.24 更新至938e439版，修正用戶清單「重新整理」按鈕導致重新整理後 LINE 欄位全部誤顯示為 FALSE 的問題，並修正 LINE 欄位錯字為；人工量測儀器組編輯表格新增「變化量(未累加)」唯讀欄位，顯示累加前的單點變化量以對照廠商定義的變化量，並將變化量計算精度由小數點後2位調整為4位
// 2026/09/04 1.26.25 更新至06e1f2f版，人工量測頁面bug修正
// 2026/09/04 1.26.26 更新至a1bad45版，暴雨預警系統登入邏輯調整
// 2026/09/08 1.26.27 更新至2c6c475版，SnakeLine 圖表右上角 e-chart 工具列滑鼠提示文字改由 i18n 提供，RainGrid SnakeLine圖形與原版同步縮放
// 2026/09/11 1.26.28 更新至70aa448版，歷時曲線頁面網址 instrument 參數改為支援逗號分隔多組儀器 ID，可一次帶入複數儀器；AI 多變數事件紀錄頁面點擊跳轉歷時曲線時，改為額外比對「同時異常儀器」名稱對應的儀器 _id 一併帶入
// 2026/09/11 1.26.29 更新至0307a1f版，改密碼／忘記密碼頁面「發送驗證碼」「重新發送驗證碼」按鈕新增 60 秒冷卻倒數，冷卻狀態存於 localStorage（依信箱區分），避免重新整理頁面後繞過冷卻再打一次 requestPasswordReset；冷卻期間按鈕停用並顯示剩餘秒數，與後端 OTP 重用機制互補
// 2026/09/30 1.26.30 更新至327b78b版，高鐵邊坡人工量測儀器類型調整
// 2026/10/07 1.26.31 更新至bf6caaf版，高捷儀表板富文本bug fix，調整詳細頁面的顯示邏輯
// 2026/10/12 1.26.32 更新至fcb1f6e版，預估表蛇行圖返回按鈕修正，人工量測高捷新增儀器可新增區域，修正高捷公開頁面之bug
// 2026/10/14 1.27.00 更新至ccdec41版，KMRT 公告新增長度檢查與錯誤提示、ArcGIS 改用非本地 CSS、台鐵與 KMRT 儀表板調整（3D 視角、儀器名稱、ELP 清單）、專案/區域/測站新增編輯流程重做、平面圖燈號可拖曳且精度到小數第一位、人工數據匯入路徑依專案分流並新增高鐵匯入頁、舊版儀表板 CCTV 影像改走 CCTV 伺服器
// 2026/10/14 1.27.01 更新至9c9aa39版，KMRT人工量測新增儀器防呆
// 2026/10/16 1.27.02 更新至6d9124e版，修正數個頁面在登出後仍不斷更新的bug

const version = '1.27.02';

module.exports = {
  version,
  //clientVersion: 'thsr-main',
  clientVersion: 'main',
  //clientVersion: 'kmrt',
  //clientVersion: 'thsr-rain',
  //clientVersion: 'test',
  //sidebar: thsr_sidebar,
  sidebar: main_sidebar,
  navbar: {
    useChanger: false,
    changerType: 'storm',
    //changerType: 'slope',
  },
  //apiUrl: 'https://api-thsr-main.geosupply.com.tw/',
  //apiUrl: 'https://api-thsr-rain.geosupply.com.tw/',
  apiUrl: 'https://api.geosupply.com.tw',
  //apiUrl: 'http://192.168.1.52:8080/',
  //apiUrl: 'http://127.0.0.1:3000/',
  //apiUrl: 'https://api-kmrt.geosupply.com.tw/',
};
